import SilentRenew from './SilentRenew';

export default SilentRenew;
